import type {RouteParams} from 'vue-router'

export function getRouteParamRecord(params: RouteParams): Record<string, string> {
  const record: Record<string, string> = {}
  for(const [key, value] of Object.entries(params)) {
    if(typeof value === 'string' && value.length) {
      record[key] = value
    }
  }
  return record
}
